/**
 * Decides whether a catalog product card should show the red "no inventory"
 * fallback badge (e.g. "0 件庫存").
 *
 * #111887: inventories arrive in a second request after the products render,
 * so the fallback must not show while that request is still in flight —
 * otherwise every product flashes red on each category switch. Once
 * inventories are loaded, the behaviour is identical to before: products
 * genuinely missing from the inventory map still show the fallback.
 */
function shouldShowNoInventoryBadge({
    inventoriesLoaded,
    inventoryExists,
    noInventoryText,
    isMatrixProduct,
    isBundle,
    minimalistInventoryVisible,
}) {
    return (
        inventoriesLoaded === true &&
        !inventoryExists &&
        // Loose inequality on purpose: preserves the original template's
        // `noInventoryTextHandler() != ''` semantics exactly.
        noInventoryText != "" &&
        !isMatrixProduct &&
        !isBundle &&
        minimalistInventoryVisible
    );
}

/**
 * Decides whether a matrix product card should show its stock badge
 * ("In Stock" / "Out of Stock").
 *
 * #111887: the matrix badge reads the inventory map directly, so it must also
 * stay hidden while the inventories request is in flight — otherwise it
 * paints a red "Out of Stock" from the empty/previous map and flips to
 * "In Stock" when the inventories arrive.
 */
function shouldShowMatrixStockBadge({ inventoriesLoaded, isMatrixProduct, minimalistInventoryVisible }) {
    return inventoriesLoaded === true && isMatrixProduct && minimalistInventoryVisible;
}

module.exports = { shouldShowNoInventoryBadge, shouldShowMatrixStockBadge };
